/**
 * BrowseInventory
 *
 * Showroom view for browsing and searching vehicle inventory.
 * Renders the search vehicle component while maintaining the showroom layout
 * with left navigation visible.
 */
import ChangeVehicleComponent from '../../ChangeVehicleComponent/ChangeVehicleComponent';
import { PageHeader, ShowroomCardContainer } from '@makemydeal/dr-sales-checkin-components';

const BrowseInventory = () => {
    return (
        <ShowroomCardContainer>
            <PageHeader isResponsive heading="Browse Inventory" />
            <ChangeVehicleComponent />
        </ShowroomCardContainer>
    );
};

export default BrowseInventory;
